import {deleteFrontendCookies, deleteUserFromLS, getAuthHeader, getQuoteAuth} from './userHelper';
import { CONSTANTS } from '@/constants/guide';
import router from '../modules/router/config';
import { store } from '@/modules/store';

export const AxiosRepo = (() => {
  function createInstance() {
    const baseURL = CONSTANTS.API.BASE_URL;
    const defaultOptions = {
      headers: { 
        'Cache-Control': 'no-cache',
      },
    }

    async function request(url, options) {
      return fetch(url, options)
      .then((response) => {
        if (response.status !== 200) {
          return Promise.reject(response);
        }

        const contentType = response.headers.get("Content-Type").split(';')
        if (!options.customUrl && contentType[0] != 'text/json') {
          return response;
        }
        return response.json();
      })
      .then(async(response) => {
        if (response.errors) {
          return Promise.reject(response.errors);
        }

        return Promise.resolve(response.response ?? response);
      }).catch((error) => {
        console.log(error);
        if (error.status === 401) {
          //Which means unauthorized
          deleteUserFromLS();
          deleteFrontendCookies();
          location.href = '/interface/Login';

          //==> try to refresh the token. TODO create end point to refresh a token on expired
          // If not possible redirect to LogIn page and remove user from local storage
          if (router.currentRoute.name !== 'LogIn') {
            store.commit('authModule/logOut');
            router.push({ name: 'LogIn' });
          }
          return Promise.reject(error);
        }

        if (
          error.status === 404 &&
          router.currentRoute.name !== 'NotFound'
        ) {
          router.push({ name: 'NotFound' });
          return Promise.reject(error);
        }

        if (typeof error === 'undefined') {
          //this This could be a CORS issue or No internet connection
          console.log('A network error occurred.');
        }
        return Promise.reject(error);
      })
    }

    function shouldAppendBaseUrl(url, options) {
      return !(options.customUrl === true || url.startsWith(CONSTANTS.API.BASE_URL));
    }

    return {
      get: async (url, options = {}) => { 
        const token = getAuthHeader();
        defaultOptions.headers.authorization = `Bearer ${token}`;

        if (shouldAppendBaseUrl(url, options)) {
          url = baseURL + url;
        }

        return await request(url, {
          method: "GET",
          ...defaultOptions,
          ...options
        })
      },
      post: async (url, data, options = {}) => { 
        const token = getAuthHeader();
        if (data && data.useCookieAuth) {
          defaultOptions.headers.authorization = `Basic ${getQuoteAuth()}`;
        } else {
          defaultOptions.headers.authorization = `Bearer ${token}`;
        }

        if (shouldAppendBaseUrl(url, options)) {
          url = baseURL + url;
        }

        return await request(url, {
          method: "POST",
          ...defaultOptions,
          ...options,
          body: options.isNotJson ? data : JSON.stringify(data),
        })
      }
    }
  }

  return {
    getInstance: () => {
      return createInstance();
    },
  };
})();
